import Component from 'core/Component';
import AnalyticsMixin from 'mixins/Analytics';
import { mix } from 'core/mixwith';
import { Event } from 'services/EventEmitter';
import { getData } from 'services/DataLayer';
import { deepMerge } from 'toolbox/deepMerge';

/**
 * component used to push specific analytics component to article pages
 * - push the event when a user scroll down at 75% (by default) and stay on the page at least 30 seconds (by default)
 * @class
 * @classdesc This is a description of the ArticleGTM class. (must be edited)
 * @extends Component
 */
export default class ArticleGTM extends mix(Component).with(AnalyticsMixin) {
    /**
     * Constructor of the class that mainly merge the options of the components
     * @param {HTMLElement} element HTMLElement of the component
     * @param {object} options options that belongs to the component
     */
    constructor(element, options = {}) {
        super(element, deepMerge({
            scrollRatio: 0.75,
            loadTimeout: 30000,
        }, options));
    }

    /**
     * Init the different state of the component
     * It helps to avoid heavy DOM manipulation
     */
    initState() {
        this.state.articleScrollEvent = 'disabled';
    }

    /**
     * Should contain only event listeners and nothing else
     * All the event handlers should be into a separated function. No usage of anonyous function
     */
    bindEvents() {
        Event.on('page.scrolled', this.onPageScrolled, this);
    }

    /**
     * After init
     * Run any script after the component is fully initialized
     */
    afterInit() {
        window.setTimeout(() => {
            if ((window.innerHeight + window.scrollY) >= (this.options.scrollRatio * document.body.offsetHeight)) {
                this.pushArticleScrollEvent();
            } else {
                this.state.articleScrollEvent = 'pending';
            }
        }, this.options.loadTimeout);
    }

    /**
     * pageScrolled event handler
     * mark page as scrolled, this is required for qualified visit event
     */
    onPageScrolled() {
        if (this.state.articleScrollEvent === 'pending') {
            if ((window.innerHeight + window.scrollY) >= (this.options.scrollRatio * document.body.offsetHeight)) {
                this.pushArticleScrollEvent();
            }
        }
    }

    /**
     * push the event when a user scroll down at 75% on articles pages and stay on the page at least 30 seconds
     */
    pushArticleScrollEvent() {
        if (this.state.articleScrollEvent !== 'pushed') {
            const pageData = Object.assign({
                page: {
                    category: '',
                    title: '',
                },
                articleName: '',
            }, getData() || {});

            const articleName = pageData.articleName || pageData.page.title;

            this.sendAnalytics({
                event: 'uaevent',
                category: pageData.page.category,
                action: 'read article',
                label: articleName,
                extraData: {
                    event_name: 'read_article',
                    article_name: articleName,
                },
            });
            this.state.articleScrollEvent = 'pushed';
        }
    }

    /**
     * Destroy is called automatically after the component is being removed from the DOM
     * You must always destroy the listeners attached to an element to avoid any memory leaks
     */
    destroy() {
        Event.removeListener('page.scrolled', this.onPageScrolled, this);
    }
}
